import React from 'react';
import ThisProject from '../ThisProject';
import { ImageMedia, Section } from '../../components/imports';

const Content = () => {

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className="projectContent">

          <Section center className={" gap-8 min-h-[50vh] resp"}>
            <ImageMedia title="m&co_pattern" src={require("./assets/LLNN Business Cards.jpg")} className=" w-full" />
          </Section>



        </div>
      )}
    </ThisProject>

  )
}

export default Content